import { render, staticRenderFns } from "./EntryDetails.vue?vue&type=template&id=6bacca86"
import script from "./EntryDetails.vue?vue&type=script&lang=js"
export * from "./EntryDetails.vue?vue&type=script&lang=js"
import style0 from "./EntryDetails.vue?vue&type=style&index=0&id=6bacca86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports